import { useMemo } from 'react'
import { operationalSupplierIdAsNumber } from '@klear/operational'
import type { Payable } from '@klear/payable/payable'
import { trpc } from '@klear/ui/lib/trpc'
import {
  orderEventForPaymentFromPayment,
  usePaymentPreviewAccounts
} from '@klear/order-event-ui/use-payment-preview-accounts'

export function usePayableCompletePreview(payable: Payable, traderId: number, enabled: boolean) {
  const payableId = payable.id ?? 0
  const paymentQuery = trpc.payable.getPaymentByPayableId.useQuery(
    { payableId, traderId },
    { enabled: enabled && payableId > 0 }
  )

  const paymentSource = useMemo(
    () => (enabled && paymentQuery.data ? orderEventForPaymentFromPayment(paymentQuery.data) : null),
    [enabled, paymentQuery.data]
  )
  const supplierId = operationalSupplierIdAsNumber(payable.primaryOperational?.supplierId ?? payable.supplierId)

  const preview = usePaymentPreviewAccounts(paymentSource, supplierId, enabled && paymentSource != null)

  const isLoading = preview.isLoading || (enabled && paymentQuery.isFetching)

  return { ...preview, isLoading }
}
